import { empApi } from "./client";

// Danh sách phiếu đăng ký chuyển giao dịch -> { items, pagination }
export const getTransferTransactionListApi = (params) => empApi.get("/transferRequests/app", params);

// Chi tiết phiếu
export const getTransferTransactionByIdApi = (id) => empApi.get(`/transferRequests/app/${id}`);
